import { useMutation, useQueryClient } from '@tanstack/react-query'
import { assignmentKeys } from './keys'
import { removeWorker } from 'api/assignment/removeWorker'
import { useCompanyInfo } from 'queries/company/useCompanyInfo'

interface UseRemoveWorkerParams {
  assignmentId: number
  workerId: number
  shiftId: number
  onError?: (error: Error) => void
}

export const useRemoveWorker = ({
  assignmentId,
  workerId,
  shiftId,
  onError,
}: UseRemoveWorkerParams) => {
  const queryClient = useQueryClient()
  const { data: company } = useCompanyInfo()
  if (!company) return

  return useMutation({
    mutationFn: (payload: Parameters<typeof removeWorker>[4]) =>
      removeWorker(company.id, assignmentId, workerId, shiftId, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: assignmentKeys.detail.byId(assignmentId),
        refetchType: 'active',
      })
    },
    onError: onError,
  })
}
